var bindPopover = function() {
  var is_touch_device = ("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch;
  if (!is_touch_device) {

    document.querySelectorAll('[rel="popover"]').forEach(function(el) {
      new bootstrap.Popover(el, {
        content: function() {
          var img = el.getAttribute("data-full-image");
          var img1 = el.getAttribute("data-full-image1");

          var rotate = String(el.getAttribute("data-full-image-rotation")).toLowerCase() === 'true';
          var rotate1 = String(el.getAttribute("data-full-image1-rotation")).toLowerCase() === 'true';

          var clazz = "popover-image";
          if (rotate) {
            clazz = clazz.concat(" popover-image-rotate");
          }

          var clazz1 = "popover-image-backside";
          if (rotate1) {
            clazz1 = clazz1.concat(" popover-image-rotate");
          }

          var result = '';
          result = result.concat(`<div class='${clazz}'><img src='${img}'></div>`);

          if (img1 != null) {
            result = result.concat(`<div class='${clazz1}'><img src='${img1}'></div>`);
          }
          return result;
        },
        delay: { show: 200, hide: 0 },
        trigger: "hover",
        placement: 'right',
        html: true,
        template: '<div class="popover-card popover"><div class="popover-arrow"></div><div class="popover-body"></div></div>'
      });
    });
  } else {
    document.querySelectorAll('[rel="popover"]').forEach(function(el) {
      if (el._popoverClickHandler) {
        el.removeEventListener('click', el._popoverClickHandler);
      }
      el._popoverClickHandler = function(e) {
        var titleEl = document.getElementById('card-popup-modal-title');
        if (titleEl) titleEl.textContent = el.textContent;
        var params = new URLSearchParams({ card_id: el.getAttribute('data-card-id') });
        fetch('/card_modal?' + params.toString(), {
          headers: { 'Accept': 'text/javascript, application/javascript' }
        }).then(function(res) { return res.text(); }).then(function(js) {
          var script = document.createElement('script');
          script.textContent = js;
          document.head.appendChild(script);
          document.head.removeChild(script);
        });
        var imgContainer = document.getElementById('card-popup-modal-image-container');
        if (imgContainer) imgContainer.innerHTML = "<img src='/assets/images/gf/back.jpg' class='price-card-image-image'>";
        bootstrap.Modal.getOrCreateInstance(document.querySelector('#card-popup-modal')).show();
        e.preventDefault();
      };
      el.addEventListener('click', el._popoverClickHandler);
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  bindPopover();
});

document.addEventListener("turbo:frame-load", function(event) {
  bindPopover();
});

document.addEventListener("turbo:before-stream-render", function(event) {
  const render = event.detail.render;

  // Wrap the default render so we hook in *after* it completes
  event.detail.render = function(streamElement) {
    render(streamElement); // perform the actual DOM update
    bindPopover();         // now run your code
  };
});
window.bindPopover = bindPopover;
